import {
  // eslint-disable-next-line no-restricted-imports
  Typography as FitifyUiTypography,
  typographyStyles,
} from 'fitify-ui/src/typography/generated/Typography'
import type { TypographyVariants } from 'fitify-ui/src/typography/generated/Typography.Types'
import type { CSSProperties } from 'react'
import { css, styled } from 'styled-components'

import { BREAKPOINTS } from '../../utils/styled'

export const Typography = styled(FitifyUiTypography)<{
  $colorHighlight?: string
  $variantMd?: TypographyVariants
  $textTransform?: CSSProperties['textTransform']
}>`
  color: ${({ $color, theme }) =>
    ($color as string) || theme.colors['N Content/Primary']};

  ${({ $variantMd }) => {
    if ($variantMd) {
      return css`
        @media ${BREAKPOINTS.MD} {
          ${typographyStyles($variantMd)};
        }
      `
    }
    return undefined
  }}

  ${({ $textTransform }) => {
    if ($textTransform) {
      return css`
        text-transform: ${$textTransform};
      `
    }
    return undefined
  }}

  ${({ $colorHighlight }) => {
    if ($colorHighlight) {
      return css`
        b {
          color: ${$colorHighlight};
          font-weight: inherit;
        }
      `
    }
    return undefined
  }}
`
